export default __webpack_public_path__ + "static/000-dd8eb682204986de7c5fbe696607f1c8.jpg";